import { ChatsModel, ContextApiInputModel, ContextOAModel, LucaEngListModel, SavedChatHistoryModel } from 'countable@model';

export class ContextGlTbModel {
  trialBalanceId: number;
  accountCode: string;
  finGroupId: number = 0;
  name: string;
  generalLedgerCYtokens: number;
  generalLedgerPY1tokens: number;
  generalLedgerPY2tokens: number;
  groupName: string;
  units: number;
  totalUnits: number;
  isRowChecked: boolean = false;
  trialBalanceYearlyTokens: number;
  uuid: string;
}

export class GroupModel {
  id: number;
  name: string;
  isChecked: boolean = false;
}

export class ContextResModel {
  isCY: boolean;
  isPY1: boolean;
  isPY2: boolean;
  trialBalance: ContextGlTbModel[] = [];
  groups: GroupModel[];
  maxTokensAllowed: number;
  selectedFinGroupIds: number[] = [];
  hasGeneralLedger: boolean;
  apiContext: ContextOAModel;
}

export class ContextGLYearModel {
  name: string;
  value: string;
  isChecked: boolean = false;
  isDisabled: boolean = false;
  gl: string;
  tb: string;
}

export const YEARS_LIST: ContextGLYearModel[] = [
  {
    name: 'Final',
    value: 'isCY',
    isChecked: false,
    isDisabled: true,
    gl: 'generalLedgerCYtokens',
    tb: 'trialBalanceYearlyTokens'

  },
  {
    name: 'PY1',
    value: 'isPY1',
    isChecked: false,
    isDisabled: true,
    gl: 'generalLedgerPY1tokens',
    tb: 'trialBalanceYearlyTokens'
  },
  {
    name: 'PY2',
    value: 'isPY2',
    isChecked: false,
    isDisabled: true,
    gl: 'generalLedgerPY2tokens',
    tb: 'trialBalanceYearlyTokens'
  }
]

export class tokenUsageModel {
  maxTokens: number = 0;
  estimatedTokens: number = 0;
  pendingTokens: number = 0;
  selectedGlRows: number = 0;
  percentage: number = 0;
  totalTokens: number = 0;
  selectedTbRows: number = 0;
  selectedOARows: number = 0;
}

export class freeContextOutputModel {
  actionType: 'CLOSE' | 'REFRESH' | 'SAVED' | 'DRAFT';
  updatedContext: ContextApiInputModel;
  contextRes: ContextResModel;
}

export class ContextInputModel {
  selectedEng: LucaEngListModel;
  selectedChat: ChatsModel;
  chatHistory: SavedChatHistoryModel;
  contextInfo: ContextResModel;
  isLoading: boolean;
}

export class ContextOtherApiRes {
  apiContext: ContextOtherApiModel[];
}

export class ContextOtherApiModel {
  apiId: number;
  description: string;
  name: string;
  isRowChecked: boolean;
  tokens: number = 0;
  totalUnits: number = 0;
  content: string;
  hasFetchedFromSource: boolean = false;
  isLoading: boolean = false;
  action: 'select' | 'deselect';
  cy: ContextOAYearInfo;
  py1: ContextOAYearInfo;
  py2: ContextOAYearInfo;
}

export interface SaveOtherApiModel {
  integration_id: number;
  chat_id: number;
  engagement_id: number;
  selections: Partial<ContextOtherApiModel>[],
  file_path: string;
  year_end_date: string;
}

export interface ContextOAYearInfo {
  isChecked: boolean;
  content: string;
  tokens: number;
}

